// エラー抑制コードを最初にインポート（AbortError 用）
// suppressErrors.ts ですべてのエラーハンドラーが設定されます
import './utils/suppressErrors';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from './state/appStore';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// アプリを初期化
initializeApp();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Service Worker registered: App is ready for offline use');
  },
  onUpdate: () => {
    console.log('Service Worker updated: New version available');
  }
});
